
import { Col, Row } from 'reactstrap';
import ValidationField from '../../../../Components/ValidationField/ValidationField';

function Form() {
  // const type = [{ lable: "other", value: "other" },{ lable: "product", value: "product"},{ lable: "order", value: "order" }]



  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>
      <ValidationField name="title_en" />
      <ValidationField name="title_ar" />
      <ValidationField name="title_de" />

 


      </Col>
      <Col>
    
      <ValidationField name="body_en" type='TextArea' />
        <ValidationField name="body_ar" type='TextArea'/>
        <ValidationField name="body_de" type='TextArea'/>
      {/* <ValidationField name="type" type="Select" option={type} /> */}


      

      </Col>



    </Row>
  )
}

export default Form




